import type { UserProgress } from '@/game-engine/state-machine/gameTypes';
import type { Question } from '@/lib/services/questions';

export const completionPreviewQuestions: Question[] = [
  {
    question_id: 101,
    stem: 'Which planet is known as the Red Planet?',
    key: 'Mars',
    distractor_1: 'Venus',
    distractor_2: 'Jupiter',
    distractor_3: 'Mercury',
    question_fact: 'Mars appears red because of iron oxide dust on its surface.',
    generation_tag_id: 1,
    breadcrumbs: [{ slug: 'space', display_name: 'Space', level: 2 }],
    source_url: 'https://example.com/mars',
  },
  {
    question_id: 102,
    stem: 'What is the fastest land animal?',
    key: 'Cheetah',
    distractor_1: 'Lion',
    distractor_2: 'Greyhound',
    distractor_3: 'Pronghorn',
    question_fact: 'A cheetah can reach top speeds of roughly 60 to 70 mph.',
    generation_tag_id: 2,
    breadcrumbs: [{ slug: 'animals', display_name: 'Animals', level: 2 }],
    source_url: 'https://example.com/cheetah',
  },
  {
    question_id: 103,
    stem: 'Who wrote Pride and Prejudice?',
    key: 'Jane Austen',
    distractor_1: 'Charlotte Brontë',
    distractor_2: 'George Eliot',
    distractor_3: 'Virginia Woolf',
    question_fact: 'Jane Austen published Pride and Prejudice in 1813.',
    generation_tag_id: 3,
    breadcrumbs: [{ slug: 'literature', display_name: 'Literature', level: 2 }],
    source_url: 'https://example.com/pride-and-prejudice',
  },
];

export const completionPreviewUserProgress: UserProgress[] = [
  {
    status: 'answered_correctly',
    guess_sequence: [0],
  },
  {
    status: 'answered_correctly',
    guess_sequence: [2, 0],
  },
  {
    status: 'answered_incorrectly_in_progress',
    guess_sequence: [1, 3, 2, 1],
  },
];

export const quizCompletionPreviewFixture = {
  adapterCompletion: {
    emojiResults: '✅2️⃣❌',
    accuracy: 67,
    totalQuestions: 3,
    xpEarned: 90,
  },
  xpBreakdown: {
    correctXP: 80,
    speedBonus: 10,
    hastePenalty: 0,
  },
  questions: completionPreviewQuestions,
  userProgress: completionPreviewUserProgress,
};

export const endlessCompletionPreviewFixture = {
  frozenGameState: {
    strikes: 1,
    boltsRemaining: 1,
    questionsAnswered: 3,
    longestStreak: 2,
    sessionTotalXP: 145,
    sessionXPBreakdown: {
      correctXP: 120,
      speedBonus: 15,
      streakBonus: 20,
      hastePenalty: 10,
    },
    attemptCounts: {
      firstTry: 1,
      secondTry: 1,
      thirdTry: 0,
      fourthTry: 1,
    },
    runQuestionHistory: [
      {
        questionId: 101,
        questionIndex: 0,
        netXP: 55,
        breakdown: {
          correctXP: 40,
          speedBonus: 10,
          streakBonus: 5,
          hastePenalty: 0,
          hastePenalties: [],
        },
        guessSequence: [0],
        isCorrect: true,
        wasAutoRevealed: false,
      },
      {
        questionId: 102,
        questionIndex: 1,
        netXP: 50,
        breakdown: {
          correctXP: 40,
          speedBonus: 0,
          streakBonus: 10,
          hastePenalty: 0,
          hastePenalties: [],
        },
        guessSequence: [2, 0],
        isCorrect: true,
        wasAutoRevealed: false,
      },
      {
        questionId: 103,
        questionIndex: 2,
        netXP: 40,
        breakdown: {
          correctXP: 40,
          speedBonus: 5,
          streakBonus: 5,
          hastePenalty: 10,
          hastePenalties: [10],
        },
        guessSequence: [1, 3, 2, 1],
        isCorrect: false,
        wasAutoRevealed: false,
      },
    ],
  },
  questions: completionPreviewQuestions,
  userProgress: completionPreviewUserProgress,
};
